// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Groots Core !! DO NOT DELETE !!
require('_groots.js');

// Display debug informations
window.groots.verbose = process.env.NODE_ENV === 'production' ? true : false;

// Require Groots JS-Plugins
window.groots.plugins = {
    grAccTabs:           require('grAccTabs/grAccTabs.js'),
    grFormUpload:        require('grFormUpload/grFormUpload.js'),
    grFormNormalize:     require('grFormNormalize/grFormNormalize.js'),
    grFormValidation:    require('grFormValidation/grFormValidation.js'),
    grGridExpander:      require('grGridExpander/grGridExpander.js'),
    grObjectfitEmulator: require('grObjectfitEmulator/grObjectfitEmulator.js'),
    grScrollTo:          require('grScrollTo/grScrollTo.js'),
    grSVGInliner:        require('grSVGInliner/grSVGInliner.js')
}; // Remove plugins you don't use from this array to not include them in your project

// ==========================================================================
// Custom Scripts
// ==========================================================================

require('./_navigation.js');
require('./_product-showcase.js');
require('./_slick.js');
require('./_popup.js');
require('./_window.js');
require('./_date.js');
require('./_inception.js');
// require('./_wow.js');
require('./_banner-video.js');
require('./_mapping.js');
require('./_form.js');
require('./_debug.js');
require('./_breadcrumb.js');
require('./_grid-expander-hash.js');
require('./_highlight.js');
require('./_schedules.js');
// require('./_grVideoYoutube.js');
require('./_home-slider.js');
require('./dataLayer/OBJ002.js');
require('./dataLayer/OBJ00-3-4-5.js');
require('./dataLayer/OBJ00-6-7.js');
require('./dataLayer/OBJ009.js');
require('./dataLayer/OBJ011.js');
require('./dataLayer/OBJ012.js');
require('./dataLayer/OBJ013.js');

(function(global) {
    'use strict';

    var select = document.querySelector('.expert-nav select');

    if (!select) {
        return;
    }

    select.addEventListener('change', triggerTab);

    function triggerTab() {
        var value = this.value;
        document.location.href = value;
    }


})(window.groots);


(function(){
    var newsletter_box_target = document.querySelector('[gr-newsletter-box-anim]');

    if (!newsletter_box_target) {
        return false;
    }

    window.addEventListener('load', function () {
        setTimeout(function(){
            newsletter_box_target.classList.toggle('is-active');
        }, 500)
    });
}());
